import { FC, useState } from "react";
import { ConflictSeverity, ConflictType, ContainerType } from "../typings/types";
import React from "react";
import { TouchableHighlight, Pressable, ImageBackground } from "react-native";
import { Button, TouchableOpacity, Text, Badge, Colors, View } from "react-native-ui-lib";
import { styles } from "../styles";
import { ConflictModal } from "./Dialogs";
import LinearGradient from "react-native-linear-gradient";
import { strings } from "../localization/localization.web";
import BallotBox from '../../assets/res/ballotBox.png';
import WindTurbine from '../../assets/res/windTurbine.png';
import philosopher from '../../assets/res/philosopher.png';

export type ConflictBadgeProps = {
    containerType: ContainerType,
    conflicts: any[],
    showConflictModalExternal?: boolean,
    setShowConflictModalExternal?: (show: boolean) => void,
}

export const ConflictBadge: FC<ConflictBadgeProps> = (
    {
        containerType,
        conflicts,
        showConflictModalExternal,
        setShowConflictModalExternal
    }
) => {

    const [showConflictModal, setShowConflictModal] = useState(false);

    let worstSeverity = conflicts.filter((conflict: any) => conflict.severity === ConflictSeverity.CRITICAL).length > 0 ?
        ConflictSeverity.CRITICAL
        : undefined;
    worstSeverity = worstSeverity === undefined ?
        conflicts.filter((conflict: any) => conflict.severity === ConflictSeverity.MAJOR).length > 0 ?
            ConflictSeverity.MAJOR
            : undefined
        : worstSeverity;
    worstSeverity = worstSeverity === undefined ?
        conflicts.filter((conflict: any) => conflict.severity === ConflictSeverity.MINOR).length > 0 ?
            ConflictSeverity.MINOR
            : undefined
        : worstSeverity;
    worstSeverity = worstSeverity === undefined ? ConflictSeverity.NONE : worstSeverity;

    let badgeStyle: any;
    switch (worstSeverity) {
        case ConflictSeverity.CRITICAL:
            badgeStyle = styles.conflictBadgeCritical;
            break;
        case ConflictSeverity.MAJOR:
            badgeStyle = styles.conflictBadgeMajor;
            break;
        case ConflictSeverity.MINOR:
            badgeStyle = styles.conflictBadgeMinor;
            break;
        default:
            badgeStyle = styles.conflictBadgeNoConflict;
            break;
    }

    const handleConflictBadgeClick = (event: any) => {
        if (setShowConflictModalExternal) {
            setShowConflictModalExternal(true);
        } else {
            setShowConflictModal(true);
        }
    }

    const handleCloseConflictModal = (event: any) => {
        if (setShowConflictModalExternal) {
            setShowConflictModalExternal(false);
        } else {
            setShowConflictModal(false);
        }
    }

    return (
        <>
            <TouchableHighlight
                onPress={handleConflictBadgeClick}
                style={{ borderRadius: 10, marginTop: 0 }}
            >
                <View style={[styles.conflictBadge, badgeStyle]} >
                </View>
            </TouchableHighlight>
            <ConflictModal
                show={showConflictModalExternal !== undefined ? false : showConflictModal}
                handleClose={handleCloseConflictModal}
                containerType={containerType}
                conflicts={conflicts}
            />
        </>

    )

}


export const GeneratedBadge: FC = () => {
    return (
        <Badge label={strings.generated} size={20} backgroundColor={Colors.backgroundAccent} />
    )
}

export const TopicBadge: FC<{ topic: string, onPress: Function }> = ({ topic, onPress }) => {
    return (
        <Pressable
            style={[
                {
                    elevation: 3,
                },
            ]}
            onPress={() => onPress()}
        >
            <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[Colors.backgroundAccent, Colors.backgroundAccent2]}
                style={[styles.borderPrimary, { width: 'auto' }]}
            >
                <View padding-2 style={[
                    {
                        elevation: 3,
                    },
                    styles.borderPrimary,
                ]}>
                    <View row flexS paddingH-10 centerV>
                        <View flex row centerV>
                            <Text h5 marginV-5 style={styles.textAccentSecondary}>
                                {topic}
                            </Text>
                        </View>
                    </View>
                </View>
            </LinearGradient>
        </Pressable>
    )
}

export const TopicCard: FC<{ topic: string, onPress: Function }> = ({ topic, onPress }) => {

    const images = {
        "Bundestagswahl": BallotBox,
        "Klimawandel": WindTurbine,
        "Philosophie": philosopher,
        "Landtagswahl Baden-Württemberg": BallotBox
    }

    const imageBackgroundColor = Colors.backgroundAccentBeige;
    const imageGradientBottomColor = Colors.secondaryBG;
    const defaultGradientBottomColor = Colors.secondaryBG;
    const defaultGradientTopColor = Colors.quinaryBG;

    return (
        <Pressable
            style={[
                {
                    elevation: 3,
                },
            ]}
            onPress={() => onPress()}
        >
            <View padding-0 style={[
                {
                    elevation: 3,
                },
                styles.borderRadiusSecondary,
            ]}>
                <View row flexS centerV style={[{ backgroundColor: imageBackgroundColor }, styles.borderRadiusSecondary]}>
                    {images[topic] ?
                        <ImageBackground
                            source={images[topic]}
                            style={[
                                {
                                    width: 100,
                                    height: 100,
                                    justifyContent: "flex-end"
                                },
                                styles.borderRadiusSecondary
                            ]}
                            imageStyle={[styles.borderRadiusSecondary, { opacity: 0.45 }]}
                        >
                            <LinearGradient
                                start={{ x: 1, y: 0.2 }}
                                end={{ x: 0, y: 0.9 }}
                                colors={[Colors.quaternaryBG + "00", imageGradientBottomColor]}
                                style={[{ height: 100, width: 'auto', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }]}
                            >
                                <View flex row style={{ justifyContent: "flex-start", alignItems: "flex-end", alignContent: "flex-end" }}>
                                    <Text h3 marginT-30 marginV-7 marginH-7 style={[styles.textPrimary, { fontWeight: "700", fontSize: 11 }]}>
                                        {topic}
                                    </Text>
                                </View>
                            </LinearGradient>
                        </ImageBackground>
                        :
                        <LinearGradient
                            start={{ x: 1, y: 0 }}
                            end={{ x: 0.4, y: 0.5 }}
                            colors={[defaultGradientTopColor, defaultGradientBottomColor]}
                            style={[
                                {
                                    width: 100,
                                    height: 100,
                                    justifyContent: "flex-end"
                                },
                                styles.borderRadiusSecondary
                            ]}
                        >
                            <View flex row style={{ justifyContent: "flex-start", alignItems: "flex-end", alignContent: "flex-end" }}>
                                <Text h3 marginT-30 marginV-7 marginH-7 style={[styles.textPrimary, { fontWeight: "700", fontSize: 11 }]}>
                                    {topic}
                                </Text>
                            </View>
                        </LinearGradient>
                    }

                </View>
            </View>
        </Pressable>
    )
}

export const ActionBadge: FC<{ label: string, onPress: Function }> = ({ label, onPress }) => {
    return (
        <Pressable
            style={[
                {
                    elevation: 3,
                },
            ]}
            onPress={() => onPress()}
        >
            <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[Colors.backgroundAccent, Colors.backgroundAccent2]}
                style={[styles.borderPrimary, { width: 'auto' }]}
            >
                <View padding-2 style={[
                    {
                        elevation: 3,
                    },
                    styles.borderPrimary,
                ]}>
                    <View row flexS paddingH-10 centerV>
                        <View flex row centerV>
                            <Text h5 marginV-5 style={styles.textAccentSecondary}>
                                {label}
                            </Text>
                        </View>
                    </View>
                </View>
            </LinearGradient>
        </Pressable>
    )
}

export const AllTopicsBadge: FC<{ onPress: Function }> = ({ onPress }) => {
    return (
        <Pressable
            style={[
                {
                    elevation: 3,
                },
            ]}
        // onPress={() => { navigation.push();}}
        >
            <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={[Colors.backgroundAccent, Colors.backgroundAccent2]}
                style={[styles.borderPrimary, { width: 'auto' }]}
            >
                <View padding-2 style={[
                    {
                        elevation: 3,
                    },
                    styles.borderPrimary,
                ]}>
                    <View row flexS paddingH-10 centerV>
                        <View flex row centerV>
                            <Text h5 marginV-5 style={styles.textAccentSecondary}>
                                {strings.all_topics}
                            </Text>
                        </View>
                    </View>
                </View>
            </LinearGradient>
        </Pressable>
    );
}